import React, { useContext, useState, useRef, useEffect } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  customStyle
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import Select from "react-select";
import DatePicker from "react-datepicker";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import "react-datepicker/dist/react-datepicker.css";
import { useReactToPrint } from "react-to-print";

//pages & includes
import ReportSidebar from "./ReportSidebar";
import ReportTypeOptions from "../../../components/Reports/ReportTypeOptions";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import { UserContext } from "../../../../contexts/User";
import ReportExcelPrintGap from "../../../components/Reports/ReportExcelPrintGap";
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import Moment from "react-moment";

const PoToPiReport = () => {
  const { t } = useTranslation();
  //getting context values here
  let {
    loading,
    dataPaginating,
    setDataPaginating,
  } = useContext(SettingsContext);
  let { branchForSearch } = useContext(RestaurantContext);
  const { authUserInfo, supplierForSearch, getSupplier } = useContext(UserContext);

  //all data
  const [reportData, setReportData] = useState(null);
  const componentRef = useRef();
  const componentRefThermal = useRef();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [branch, setBranch] = useState(null);
  const [supplier, setSupplier] = useState(null);
  const [generatedReport, setGeneratedReport] = useState(false);
  const [option, setOption] = useState("excel");
  const [viewDetailReport, setViewDetailReport] = useState(false);

  useEffect(() => {
    if(!supplierForSearch){
      getSupplier();
    }
  }, []);

  const thermalPrint = useReactToPrint({
    content: () => componentRefThermal.current,
    pageStyle: `
        @page {
          margin: 15px 7px;
        }
      `,
  });

  const handleBranch = (branch) => {
    setBranch(branch);
  };

  const handleSupplier = (item) => {
    setSupplier(item);
  };

  const handleOption = (e) => {
    setOption(e.target.value);
    if(option !== "view"){
      setViewDetailReport(false)
    }
  };

  //get BranchWise reports filter
  const getBranchWiseFilter = () => {
    setReportData(null);
    setGeneratedReport(false);
    setViewDetailReport(false);
    if (
      (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") &&
      !branch?.[0]?.id
    ) {
      toast.error(`${_t(t("Please select branch to generate report"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }
    if (startDate !== null && endDate !== null) {
      setDataPaginating(true);
      let fromDate = moment(startDate).format("YYYY-MM-DD");
      let toDate = moment(endDate).format("YYYY-MM-DD");
      const url = BASE_URL + "/settings/po-to-pi-report";
      const brnch = branch && branch?.length ? branch.map((branh)=> branh.id) : "";
      const suplier = supplier?.length ?  supplier.map((sup)=>sup.id) : "";

      const formData = {
        fromDate: fromDate,
        toDate: toDate,
        branch_id: brnch,
        supplier_id: suplier ?? ""
      }

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          console.log("ReportResult", res);
          setGeneratedReport(true);
          setReportData(res.data.data);
          setDataPaginating(false);
          if (option === "excel") {
            componentRef.current.handleDownload();
          } else if (option === "view") {
            setViewDetailReport(true)
          } else {
            thermalPrint();
          }
        })
        .catch((error) => {
          setDataPaginating(false);
        });
    } else {
      toast.error(`${_t(t("Please select from date and to date"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  const header = [
    { name: "Branch Name", key: "branch_name" },
    { name: "Supplier Name", key: "supplier_name" },
    { name: "PO Date", render:(item)=> <> {item.po_date ? <Moment format="LL">{item.po_date}</Moment> : ""} </>},
    { name: "PO Number", key: "po_no" },
    { name: "PO Created At", render:(item)=> <> {item.po_created_at ? <Moment format="LL">{item.po_created_at}</Moment> : ""} </> },
    { name: "PO Delivery Date",  render:(item)=> <> {item.po_delivery_date ? <Moment format="LL">{item.po_delivery_date}</Moment> : ""} </> },
    { name: "PO Quantity", key: "po_qty" },
    { name: "PO Item Name", key: "po_item_name" },
    { name: "PO Unit Name", key: "po_unit_name" },
    { name: "PO Rate", key: "po_rate" },
    { name: "PO Status", key: "po_status" },

    { name: "GRN Number", key: "grn_no" },
    { name: "GRN Date", render:(item)=> <> {item.grn_date ? <Moment format="LL">{item.grn_date}</Moment> : ""} </> },
    { name: "GRN Rate", key: "grn_rate" },
    { name: "GRN Quantity", key: "grn_qty" },
    { name: "GRN Item Name", key: "grn_item_name" },
    { name: "GRN Unit Name", key: "grn_unit_name" },
    { name: "GRN Status", key: "grn_status" },

    { name: "Balanced Quantity", key: "balanced_qty" },

    { name: "PI Number", key: "pi_no" },
    { name: "PI Amount", key: "pi_amount" },
    { name: "PI Date", key: "pi_date" },
    { name: "PI Item Name", key: "pi_item_name" },
    { name: "PI Unit Name", key: "pi_unit_name" },
    { name: "PI Quantity", key: "pi_qty" },
    { name:"Pi Status", key: "pi_status" }
  ]

  return (
    <>
      <Helmet>
        <title>{_t(t("Po To Pi Report"))}</title>
      </Helmet>

      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Po To Pi Report"
        sheet="sheet 1"
        buttonText="Download"
        ref={componentRef}
      />

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading || dataPaginating}/>
                    {/* spin loading ends */}
                    <div key="smtp-form">
                      <div className="gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="row t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb col-6">
                            <li className="fk-breadcrumb__list">
                              <span className="pl-3 t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Po To Pi Report"))}
                              </span>
                            </li>
                          </ul>
                          <div className="col-6 d-flex justify-content-end">
                            <ReportTypeOptions
                              selectedOption={option}
                              onChange={handleOption}
                              view={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-2">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control t-mb-15"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={true}
                          />
                        </div>

                        <div className="col-2">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control t-mb-15"
                            placeholderText={_t(t("To date"))}
                            shouldCloseOnSelect={true}
                          />
                        </div>

                        <div className="col-3">
                          <Select
                            options={branchForSearch ? branchForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={branch}
                            styles={customStyle}
                            isMulti
                            isClearable
                            classNamePrefix="select"
                            className="table-text"
                            onChange={handleBranch}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a branch")) + ".."}
                          />
                        </div>

                        <div className="col-3">
                          <Select
                            options={supplierForSearch ? supplierForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={supplier}
                            styles={customStyle}
                            isClearable
                            isMulti
                            classNamePrefix="select"
                            className="table-text"
                            onChange={handleSupplier}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select Supplier")) + ".."}
                          />
                        </div>

                        <div className="col-2 t-mb-15 text-right">
                          <button
                            className="ml-1 btn btn-block btn-primary sm-text py-2 rounded"
                            onClick={(e) => getBranchWiseFilter()}
                          >
                            REPORT
                          </button>
                        </div>
                      </div>
                      <ReportExcelPrintGap
                        header={header}
                        generatedReport = {generatedReport}
                        viewDetailReport = {viewDetailReport}
                        heading="Po To Pi Report"
                        reportData={reportData}
                        startDate={startDate}
                        endDate={endDate}
                        componentRef={componentRef}
                        printRef={componentRefThermal}
                        branch={{
                          name: branch?.length ? branch.map((branh,i)=> branh.name + (i < branch?.length -1) ? ", " : "" ) : "All Branch",
                          show: true,
                        }}
                        type = {option}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
    </>
  );
};

export default PoToPiReport;
